<div *ngIf="formEvent" class="p-4">
  <form [formGroup]="formEvent" (submit)="save()" class="flex flex-col gap-4">
    <div *ngIf="canAssignToSelf" class="flex items-center gap-2">
      <p-inputSwitch formControlName="assignToSelf" (onChange)="onAssignToSelfChange()" />
      <label>Assegna a me</label>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <p-dropdown
          [options]="filteredEventTypes"
          formControlName="eventType"
          optionLabel="label"
          optionValue="code"
          [placeholder]="'Tipo'"
          styleClass="w-full"
          (onChange)="selectEventMedium(); checkOrAddProperty(); checkSelectProperty(); checkEventAvailability()"
          appendTo="body"
        >
        </p-dropdown>

        <p *ngIf="mustAddProperty" class="text-red-500 mt-2 cursor-pointer hover:underline" (click)="goToOpportunity()">
          Devi aggiungere almeno un immobile per questo tipo di attività.
        </p>
        <p-dropdown
          *ngIf="mustSelectProperty"
          [options]="propertyProjectList"
          formControlName="connectedProject"
          [placeholder]="'Immobile'"
          styleClass="w-full mt-4"
          appendTo="body"
        >
        </p-dropdown>
      </div>

      <div>
        <range-date-picker formControlName="eventRange" class="w-full" (ngModelChange)="checkEventAvailability()" />
      </div>

      <div class="md:col-span-2" *ngIf="eventMedium === 1 && !assignToSelf">
        <label for="address" class="text-lg font-medium">Indirizzo</label>
        <address-input id="address" class="w-full my-2" formControlName="address"></address-input>
      </div>

      <div class="md:col-span-2">
        <p-dropdown
          [options]="slots"
          formControlName="slot"
          [placeholder]="assignToSelf ? 'Slot orario — Io' : 'Slot orario - Consulente'"
          styleClass="w-full"
          appendTo="body"
          [virtualScroll]="true"
          [virtualScrollItemSize]="40"
          [filter]="true"
          [filterFields]="['slot', 'account']"
        >
          <ng-template let-item pTemplate="item">
            <div>{{ item.slot | date : 'dd/MM/yyyy HH:mm' : 'it' }}<span *ngIf="!assignToSelf"> - {{ item.account }}</span></div>
          </ng-template>
          <ng-template pTemplate="selectedItem" let-option>
            <div>{{ option.slot | date : 'dd/MM/yyyy HH:mm' : 'it' }}<span *ngIf="!assignToSelf"> - {{ option.account }}</span></div>
          </ng-template>
        </p-dropdown>
      </div>

      <div>
        <input pInputText [placeholder]="'Note *'" formControlName="note" class="w-full" />
        <div *ngIf="formEvent.get('note')?.errors" class="mt-2">
          <small class="text-red-500">Inserisci almeno 5 caratteri per le note</small>
        </div>
      </div>

      <div>
        <input pInputText [placeholder]="'Link video call'" formControlName="connectionInfo" class="w-full" *ngIf="eventMedium === 2" />
        <input pInputText [placeholder]="'Telefono'" formControlName="connectionInfo" class="w-full" *ngIf="eventMedium === 3" />
      </div>
    </div>

    <div class="flex justify-end gap-2 mt-4">
      <button type="button" pButton (click)="close()" label="Annulla" class="p-button-text"></button>
      <button type="submit" pButton [disabled]="!formEvent.valid" label="Crea" class="p-button-primary"></button>
    </div>
  </form>
</div>
